import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import SplitPickup from '../../components/SplitPickup/SplitPickup';
import PickupButtons from '../../components/PickupButtons/PickupButtons';
import classes from './AdminPickup.css';
import * as actions from '../../store/actions/index';

class AdminPickup extends Component {
    state = {
        pickup:null,
        hardwood:0,
        cedar:0,
        black:0,
        red:0,
        created: false
    }
    componentDidMount () {
        for (let k in this.props.pickupSummary) {
            if (this.props.pickupSummary[k].userId == this.props.filteredUserId) {

                this.setState({pickup:this.props.pickupSummary[k]});
                break;
            }
        }
        
    }
    
    componentWillUpdate = () => {
       
        if (this.props.pickupCreated) {
        }
    }

    loading = (mulchType,bags) => {
        if (bags == '') {
            bags = 0;
        }
        this.setState({[mulchType]:bags});
    }

    cancelled = () => {
        this.props.history.push('/pickupSummary');
    }

    loadPickup = () => {
        this.props.onAddPickup(this.props.filteredUserId,this.state.hardwood,this.state.cedar,this.state.black,this.state.red);
        this.props.history.push('/pickupSummary?Pickup Added');
    }


    render () {
        
        let hardwood = null;
        let cedar = null;
        let black = null;
        let red = null;
        let scout = '';
        let totalTaken = 0;
        let totalRemaining = 0;
        
        totalTaken = parseInt(this.state.hardwood) + parseInt(this.state.cedar) + parseInt(this.state.black) + parseInt(this.state.red);
        if (this.state.pickup) {
            totalRemaining = (this.state.pickup.hardwoodBagsRemaining + this.state.pickup.cedarBagsRemaining +
                this.state.pickup.blackBagsRemaining + this.state.pickup.redBagsRemaining) - totalTaken;
        }

        if (this.state.pickup) {
            
            if (this.state.pickup.hardwoodBagsRemaining > 0) {
                hardwood = <SplitPickup mulchType='Hardwood' loading={this.loading} remaining={this.state.pickup.hardwoodBagsRemaining} /> 
            }
            if (this.state.pickup.cedarBagsRemaining > 0) {
                cedar = <SplitPickup mulchType='Cedar' loading={this.loading}  remaining={this.state.pickup.cedarBagsRemaining} /> 
            }
            if (this.state.pickup.blackBagsRemaining > 0) {
                black = <SplitPickup mulchType='Black' loading={this.loading}  remaining={this.state.pickup.blackBagsRemaining} /> 
            }
            if (this.state.pickup.redBagsRemaining > 0) {
                red = <SplitPickup mulchType='Red' loading={this.loading}  remaining={this.state.pickup.redBagsRemaining} /> 
            }
            scout = this.state.pickup.scout;
        }
        
        return (
           
            <div className={classes.AdminPickup}>


                <h1><strong>{scout}</strong></h1>
                <SplitPickup mulchType='TYPE'  />
                {hardwood}
                {cedar}
                {black}
                {red}
                <SplitPickup mulchType='TOTAL' totalRemaining={totalRemaining} totalTaken={totalTaken}  />
                <PickupButtons onLoad={this.loadPickup} onCancelled={this.cancelled} />
            </div>
                   );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.orders.token !== null,
        pickupSummary: state.orders.pickupSummary
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAddPickup : (userId,hardwood,cedar,black,red) => dispatch(actions.addPickup(userId,hardwood,cedar,black,red))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( AdminPickup );


// WEBPACK FOOTER //
// ./src/containers/AdminPickup/AdminPickup.js